export default __webpack_public_path__ + "static/media/ill-courses.0708e723.png";